import axios from "@/config/axios";
export default {
    //预约咨询
    wx_make_add : data => axios.post("/index.php/Home/index/wx_make_add", data),
};
